import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { 
  MainBodyContent, 
  CustomButton,
  SearchList,
  TablePagination
} from 'components'
import { 
  goodsServiceReceiptDetailPath,
  goodsServiceReceiptEditPath,
  goodsServiceReceiptCreatePath
} from 'routes'
import {
  columns
} from './AttributeData'
import { 
  fetchGRList
} from 'ducks/goodsServiceReceipt'

import { GRListCont } from './styled'
import { 
  ProcurementContainer, 
  ProcurementBody 
} from '../styled'

const GoodsServiceReceipt = (props) => {

  const { 
    grList ,
    valueForm
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(() => {
    props.fetchGRList({page:1,size:pageSize})
  },[])

  return (
    <MainBodyContent
      headerTitle="Goods Service Receipt"
      accessoriesHeader={
        <div style={{ display: 'flex' }}>
          <CustomButton
            onClick={() => props.history.push(goodsServiceReceiptCreatePath)}
            icon="plus"
            btnColor="gray"
            title="Create"
          />
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList pageSize={pageSize} fetchAPI={props.fetchGRList} formSearchName='formSearchGR' filterDate filterStatus/>
          <GRListCont>
            <ReactTable 
              data={Object.keys(grList).length>0?grList.data:[]}
              columns={columns.tRFQs}
              defaultPageSize={userPageSize}
              noDataText="No GoodsServiceReceipt found"
              previousText={<Icon name="arrow alternate circle left" />}
              nextText={<Icon name="arrow alternate circle right" />}
              className="-striped -highlight"

              PaginationComponent={TablePagination}
              pages={Object.keys(grList).length>0?grList.totalPage:0}
              currentPage={Object.keys(grList).length>0?grList.page:0}
              onPageChange={(pageIndex) => {
                props.fetchGRList({...valueForm,page:pageIndex+1,size:pageSize})
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.fetchGRList({...valueForm,page:pageIndex+1,size:pageSize})
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0, 5, 1].indexOf(rowInfo.original.status) >= 0) {
                        window.open(goodsServiceReceiptEditPath(rowInfo.original.id))
                      } else {
                        window.open(goodsServiceReceiptDetailPath(rowInfo.original.id))
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </GRListCont>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = state => ({
  grList: state.gr.grList,
  valueForm: getFormValues('formSearchGR')(state)
})

const mapDispatchToProps = {
  fetchGRList
}

const contForm = reduxForm({
  form: 'formSearchGR',
  enableReinitialize: true,
})(GoodsServiceReceipt)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)
